module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-cove-timber-hamilton-1.b3c4ec99.jpg";